// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2580b055","513":"ecce6222","703":"9744b690","787":"dced2e1c"}[chunkId] + ".chunk.js";
};